export const USERS_ROUTE_PATH = {
  users: {
    list: { path: "/admin/users" },
    new: {
      path: "/admin/users/new",
    },
    edit: {
      path: "/admin/users/:userId/edit",
      pathBuilder: (userId: string) => `/admin/users/${userId}/edit`,
    },
  },
};
